import { render } from "./PatientChart.vue?vue&type=template&id=2dafc5c4&scoped=true"
import script from "./PatientChart.vue?vue&type=script&lang=js"
export * from "./PatientChart.vue?vue&type=script&lang=js"

import "./PatientChart.vue?vue&type=style&index=0&id=2dafc5c4&lang=css"
import "./PatientChart.vue?vue&type=style&index=1&id=2dafc5c4&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dafc5c4"]])

export default __exports__